import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { SocialProofBar } from '../components/home/SocialProofBar';
import { FeaturedDepartments } from '../components/home/FeaturedDepartments';
import { FeaturedProducts } from '../components/home/FeaturedProducts';
import { SpecialsSection } from '../components/home/SpecialsSection';
import { LatestCatalogue } from '../components/home/LatestCatalogue';
import { TrustedBrands } from '../components/home/TrustedBrands';
import { CustomerTestimonials } from '../components/home/CustomerTestimonials';
import { WhyShopSection } from '../components/home/WhyShopSection';
import { CustomerCareClub } from '../components/home/CustomerCareClub';
import { NewPetJourney } from '../components/home/NewPetJourney';
import { DeliveryExplainer } from '../components/home/DeliveryExplainer';
import { StoreLocator } from '../components/home/StoreLocator';
import { ExpertAdvice } from '../components/home/ExpertAdvice';
import { FAQSection } from '../components/home/FAQSection';
import { StickyCCCBanner } from '../components/home/StickyCCCBanner';
interface HomePageProps {
  onNavigate: (page: 'shop' | 'product') => void;
}
export function HomePage({
  onNavigate
}: HomePageProps) {
  return <main className="bg-white" data-id="element-681">
      {/* 1. Hook — cinematic hero with sliding backgrounds */}
      <HeroSection onNavigate={onNavigate} data-id="element-682" />

      {/* 2. Instant Trust — delivery, rating, WA owned, locations */}
      <SocialProofBar data-id="element-683" />

      {/* 3. Navigate — shop by department */}
      <FeaturedDepartments onNavigate={onNavigate} data-id="element-684" />

      {/* 4. Discover — popular products */}
      <FeaturedProducts onNavigate={onNavigate} data-id="element-685" />

      {/* 5. Urgency — this week's specials */}
      <SpecialsSection data-id="element-686" />

      {/* 6. Engagement — latest catalogue */}
      <LatestCatalogue data-id="element-687" />

      {/* 7. Authority — brand logos (MOVED UP for trust funnel) */}
      <TrustedBrands data-id="element-688" />

      {/* 8. Social Proof — customer testimonials */}
      <CustomerTestimonials data-id="element-689" />

      {/* 9. Brand Story — why shop with us + services */}
      <WhyShopSection data-id="element-690" />

      {/* 10. Conversion — Customer Care Club (trust at peak) */}
      <CustomerCareClub data-id="element-691" />

      {/* 11. Lead Gen — starter guides (4 personas) */}
      <NewPetJourney data-id="element-692" />

      {/* 12. Logistics — free 5km delivery hero */}
      <DeliveryExplainer data-id="element-693" />

      {/* 13. Local — find your store */}
      <StoreLocator data-id="element-694" />

      {/* 14. Content/SEO — expert advice */}
      <ExpertAdvice data-id="element-695" />

      {/* 15. Friction Reducer — FAQ */}
      <FAQSection data-id="element-696" />

      {/* Sticky CCC Banner — appears after scrolling past CCC */}
      <StickyCCCBanner data-id="element-697" />
    </main>;
}